__turbopack_context__.v({
  "currentDropDown": "index-module__On6YDa__currentDropDown",
  "dropDownContent": "index-module__On6YDa__dropDownContent",
  "dropDownItem": "index-module__On6YDa__dropDownItem",
  "languageDropdown": "index-module__On6YDa__languageDropdown",
});
